<template>
  <form id="app" action="complete" method="POST" @submit.prevent="submit">
    <Navigation v-if="$route.name !== 'auth' && $route.name !== 'pilot'"/>
    <main :data-route="$route.name">
      <router-view/>
    </main>
    <Foot v-if="$route.name !== 'auth' && $route.name !== 'pilot'"/>
  </form>
</template>

<script>
  import Navigation from '@/components/Navigation.vue'
  import Foot from '@/components/Foot.vue'

  import 'normalize.css';

  export default {
    components: {
      Navigation,
      Foot,
    },
    methods: {
      async submit(e) {
        if( this.$route.meta.next ) {
          // Prevent accidental submit in first steps
          this.$router.push({name: this.$route.meta.next})
        } else {
          try {
            if(!navigator.onLine) throw 'Connexion impossible pour le moment. Vos données sont sauvegardées sur cet appareil, veuillez réessayer ultérieurement.'
            await this.$store.dispatch('uploadForm', {
              url: e.target.attributes.action.value
            })
            this.$router.push({name: 'end'})
            this.$store.dispatch('resetDatas')
            this.$store.dispatch('logout')
          } catch (error) {
            alert(error)
          }
        }
      }
    }
  }
</script>

<style lang="scss">
  @import '@/assets/_vars.scss';

  * {
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-tap-highlight-color: rgba(black,0);
  }

  *:focus {
    outline-offset: 2px;
    outline-color: color('link');
  }

  html, body {
    height: 100%;
    font-family: 'allianz-sans', Arial, sans-serif;
    font-size: 16px;
    line-height: 1.42857143;
    color: color('text');
    background-color: color('background');
  }

  #app {
    display: flex;
    flex-direction: column;
    min-height: 100%;
  }

  main {
    flex: 1 0 auto;
    position: relative;
    background-color: white;

    @include media('>tablet') {
      &:not([data-route="auth"]) {
        width: map-get($breakpoints, 'tablet');
        padding: 0 calc(50vw - #{map-get($breakpoints, 'tablet')} / 2);
        box-sizing: content-box;
      }
    }
  }

  a {
    color: color('secondaryBlue');
  }

  img {
    display: block;
    max-width: 100%;
    height: auto;
  }

  label {
    display: block;
    font-size: .9em;
    color: color('secondaryBlue');
    cursor: pointer;

    sup {
      color: red;
    }
  }

  [type="submit"],
  [type="button"] {
    cursor: pointer;
  }
</style>
